import { t } from '../i18n/ru';
import { useController } from '../state/context';
import { Modal } from './Modal';

export function GenerateModal() {
  const c = useController();
  const gen = c.generation.value;
  if (!gen) return null;
  return (
    // Пока идёт генерация, закрыть окно нельзя; после ошибки — можно
    <Modal labelId="gen-title" onClose={gen.failed ? () => c.closeGeneration() : undefined}>
      <div class="orb" aria-hidden="true">
        <i class="r1" />
        <i class="r2" />
        <i class="core" />
        <i class="sat" />
      </div>
      <h2 id="gen-title" class="orb-title">
        {t.gen.title}
      </h2>
      <ul class="steps" data-testid="gen-steps">
        {t.gen.steps.map((label, k) => {
          const n = k + 1;
          const done = n < gen.step || (gen.step === 3 && !gen.failed);
          const cls = done ? 'done' : n === gen.step && !gen.failed ? 'on' : '';
          return (
            <li class={cls} key={label}>
              {done ? '✓ ' : cls === 'on' ? <span class="spin" /> : null}
              {label}
            </li>
          );
        })}
      </ul>
      <div class="note" data-testid="gen-note" role="status">
        {gen.note}
      </div>
      {gen.failed && (
        <div class="btns">
          <button type="button" onClick={() => c.closeGeneration()}>
            {t.gen.close}
          </button>
        </div>
      )}
    </Modal>
  );
}
